import React, { useEffect, useState } from "react";
import {
  ChevronLeftIcon,
  MinusIcon,
  PlusIcon,
  SearchIcon,
} from "@heroicons/react/outline";
import SMSelect from "../../elements/select/SMSelect";
import { useHistory, useParams } from "react-router-dom";
import axiosAPI from "../../utils/axios-api";
import SMModal from "../../elements/modals/SMModal";
import swal from "sweetalert2";
import ButtonPrimary from "../../elements/button/ButtonPrimary";

const API = process.env.REACT_APP_API;

const UndangKuesioner = () => {
  let { idKuesioner } = useParams();
  const [availableUser, setavailableUser] = useState([]);
  const [selectedUser, setselectedUser] = useState([]);
  const [search, setsearch] = useState("");
  const [modalKirim, setmodalKirim] = useState(false);
  const [modalHitung, setmodalHitung] = useState(false);
  const [loadingKirim, setloadingKirim] = useState(false);

  // State for pembayaran scoin
  const [biaya, setBiaya] = useState(null);
  const [biaya_admin, setBiayaAdmin] = useState(null);
  const [komisi, setKomisi] = useState(null);
  const [total, setTotal] = useState(null);
  const [pin, setPin] = useState(null);
  const [transaksi_id, setTransaksiId] = useState(null);
  const [responden, setResponden] = useState([]);

  let type = [
    { value: "table", label: "table" },
    { value: "grid", label: "grid" },
  ];

  useEffect(() => {
    getAvailableUser();
  }, []);

  function getAvailableUser(params) {
    axiosAPI
      .get(API + "user/" + idKuesioner + "/available-user")
      .then((res) => {
        setavailableUser(res.data.data);
      });
  }

  function setSearch(nama) {
    axiosAPI
      .get(API + "user/" + idKuesioner + "/available-user?nama=" + nama)
      .then((res) => {
        setavailableUser(res.data.data);
        // setsearch(res.data.data)
      });
  }

  function undangResponden(params) {
    setloadingKirim(true);
    let user_id = [];
    for (let index = 0; index < selectedUser.length; index++) {
      user_id.push(selectedUser[index].id);
    }
    let body = {
      user_id: user_id,
    };
    axiosAPI
      .post(API + "responden/" + idKuesioner + "/undang-responden", body)
      .then((res) => {
        setloadingKirim(false);
        setmodalKirim(true);
      })
      .catch((err) => {
        setloadingKirim(false);
      });
  }

  function increaseUser(params) {
    setselectedUser([...selectedUser, params]);
  }

  function decreaseUser(params) {
    let deleted = selectedUser.filter((val) => val.id !== params.id);

    setselectedUser(deleted);
  }

  function hitungScoin() {
    setloadingKirim(true);
    const userData =
      JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};

    const payload = {
      subject: {
        type: "INVITE_KUISIONER_TERTUTUP",
        id: idKuesioner, // ref id : ex. event id, kuisioner id, etc
      },
      actor: {
        email: userData.email, // creator
      },
      recipients: [],
      metadata: {},
    };

    if (selectedUser.length <= 0) {
      swal.fire("Gagal", "Pilih responden terlebih dahulu", "error");
      return;
    }

    axiosAPI.get(API + "kuesioner/" + idKuesioner).then((res) => {
      let data = res.data.data;
      // let tipe_kuesioner = data.sifat === 0 ? "terbuka_undang" : "tertutup";
      // setTypeOfKuesioner(tipe_kuesioner);
      // let body = {
      //   kode_kuesioner: data.kode_kuesioner,
      //   responden: username,
      //   biaya: data.scoin,
      //   type: tipe_kuesioner,
      // };
      let username = [];
      for (let index = 0; index < selectedUser.length; index++) {
        username.push({
          email: selectedUser[index].email,
          amount: data.scoin,
        });
      }
      payload.recipients = username;
      payload.subject.id = data.id;
      setResponden(username);

      axiosAPI
        .post(API + "scoin/hitung", payload)
        .then((res) => {
          let terhitung = res.data;

          setBiaya(terhitung.amounts.reward_pool ?? 0);
          setBiayaAdmin(terhitung.amounts.creation_fee ?? 0);
          setKomisi(terhitung.amounts.commission_amount ?? 0);
          setTotal(terhitung.amounts.net_debit ?? 0);
          setTransaksiId(terhitung.transaction_id);
          setloadingKirim(false);
          setmodalHitung(true);
        })
        .catch((xhr) => {
          console.log(xhr);
        });
    });
  }

  function bayarScoin() {
    let body = {
      pin: pin,
      kuesioner_id: idKuesioner,
      transaksi_id: transaksi_id,
      responden: responden,
      harga: biaya,
    };

    axiosAPI
      .post(API + "scoin/bayar", body)
      .then((res) => {
        let data = res.data;
        if (data.success == false) {
          swal.fire("Gagal", data.error, "error");
        } else {
          swal.fire("Berhasil", "Berhasil Mengundang Peserta Kuesioner", "success");
        }
      })
      .catch((xhr) => {
        console.log(xhr);
      });
  }

  return (
    <>
      {/* modal kirim */}
      <SMModal
        title="Kirim undangan"
        show={modalKirim}
        onClose={() => {
          setmodalKirim(!modalKirim);
          window.history.back();
        }}
      >
        <div className="flex flex-col py-4 px-4">
          <h1>Berhasil mengirim undangan</h1>
          <div className="flex">
            <button
              onClick={() => window.history.back()}
              className="px-4 py-2 text-white rounded bg-green-500"
            >
              <p>Oke</p>
            </button>
          </div>
        </div>
      </SMModal>

      {/* modal kirim */}
      <SMModal
        title="Bayar untuk mengundang Responden"
        show={modalHitung}
        onClose={() => {
          setmodalHitung(!modalHitung);
          window.history.back();
        }}
      >
        {/* Table rincian pembayaran */}
        <div className="flex flex-col justify-center h-full">
          <div className="w-full max-w-2xl mx-auto bg-white shadow-lg rounded-sm border border-gray-200">
            <div className="p-3">
              <div className="overflow-x-auto">
                <table className="table-auto w-full table-bordered">
                  <thead className="text-xs font-semibold uppercase text-gray-400 bg-gray-50">
                    <tr>
                      <th className="p-2 whitespace-nowrap">
                        <div className="font-semibold text-left">Biaya</div>
                      </th>
                      <th className="p-2 whitespace-nowrap">
                        <div className="font-semibold text-left" id="biaya">
                          {biaya}
                        </div>
                      </th>
                    </tr>
                    <tr>
                      <th className="p-2 whitespace-nowrap">
                        <div className="font-semibold text-left">
                          Biaya Admin
                        </div>
                      </th>
                      <th className="p-2 whitespace-nowrap">
                        <div
                          className="font-semibold text-left"
                          id="biaya_admin"
                        >
                          {biaya_admin}
                        </div>
                      </th>
                    </tr>
                    <tr>
                      <th className="p-2 whitespace-nowrap">
                        <div className="font-semibold text-left">Komisi</div>
                      </th>
                      <th className="p-2 whitespace-nowrap">
                        <div className="font-semibold text-left" id="komisi">
                          {komisi}
                        </div>
                      </th>
                    </tr>
                    <tr>
                      <th className="p-2 whitespace-nowrap">
                        <div className="font-semibold text-left">
                          Total Bayar
                        </div>
                      </th>
                      <th className="p-2 whitespace-nowrap">
                        <div
                          className="font-semibold text-left"
                          id="total_bayar"
                        >
                          {total}
                        </div>
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
          </div>
        </div>

        <p className="my-2">Masukkan PIN</p>
        <input
          type="password"
          inputMode="numeric"
          placeholder="Masukkan PIN disini"
          maxLength={6}
          className="w-full h-12 text-center text-xl border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
        />

        <p className="text-sm text-red-700" id="errorpembayaran"></p>

        <div className="flex flex-row mt-2 gap-2 justify-end">
          <ButtonPrimary
            // onClick={() => kirimPersetujuan({ status: 1 })}
            onClick={() => bayarScoin()}
            text="Bayar"
            type="solid"
          />
          <ButtonPrimary
            onClick={() => setmodalHitung(false)}
            text="Batal"
            type="outline"
          />
        </div>
      </SMModal>

      <div className="flex flex-col dark:text-white pt-16 px-10">
        <div className="w-full">
          <button
            onClick={() => window.history.back()}
            className="flex flex-row items-center"
          >
            <ChevronLeftIcon className="h-4 w-4 mr-2" />
            <p>Kembali</p>
          </button>
        </div>
        <div className="flex flex-row">
          <div className="flex flex-col w-2/6 p-2">
            <div className="flex flex-col rounded-xl bg-gray-200 p-4">
              <h1 className="text-md font-bold">Daftar User</h1>

              <div className="flex flex-row my-2 rounded bg-white">
                <input
                  onKeyUp={(e) => setSearch(e.target.value)}
                  // value={search}
                  type="text"
                  className="p-2 rounded flex-1"
                />
                <button className="flex py-2 px-2 rounded-r bg-green-500 items-center text-white">
                  <SearchIcon className="h-4 w-4 " />
                </button>
              </div>

              <div
                className="flex flex-col"
                style={{
                  minHeight: "10rem",
                }}
              >
                {availableUser.map((val, idx) => {
                  if (!!!selectedUser.find((x) => x.id === val.id)) {
                    if (val.nama.match(search)) {
                      return (
                        <div
                          key={idx}
                          className="flex flex-row justify-between pt-4 pb-2 border-b border-gray-400"
                        >
                          <p className="text-sm font-semibold">{val.nama}</p>
                          <button
                            onClick={() => increaseUser(val)}
                            className="p-1 rounded drop-shadow-lg bg-green-500 text-white"
                          >
                            <PlusIcon className="h-4 w-4" />
                          </button>
                        </div>
                      );
                    }
                  }
                })}
              </div>
            </div>
          </div>
          <div className="flex flex-col w-2/6 p-2">
            <div className="flex flex-col rounded-xl bg-gray-200 p-4">
              <h1 className="text-md font-bold">Daftar Undangan</h1>
              <div
                className="flex flex-col"
                style={{
                  minHeight: "10rem",
                }}
              >
                {selectedUser.length < 1 ? (
                  <div className="flex justify-center items-center flex-1">
                    Pilih user terlebih dahulu
                  </div>
                ) : (
                  selectedUser.map((val, idx) => {
                    return (
                      <div
                        key={idx}
                        className="flex flex-row justify-between pt-4 pb-2 border-b border-gray-400"
                      >
                        <p className="text-sm font-semibold">{val.nama}</p>
                        <button
                          onClick={() => decreaseUser(val)}
                          className="p-1 rounded drop-shadow-lg bg-red-500 text-white"
                        >
                          <MinusIcon className="h-4 w-4" />
                        </button>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
          <div className="flex flex-col w-2/6 p-2">
            <div className="flex flex-col rounded-xl bg-gray-200 p-4">
              <h1 className="text-md font-bold">Buat Undangan</h1>
              <p className="mt-4">
                Menyiapkan undangan untuk kuesioner {idKuesioner}
              </p>

              <div className="flex my-2">
                {selectedUser.length < 1 ? null : loadingKirim ? (
                  <button className="px-4 py-2 rounded text-black bg-gray-300">
                    <p>Loading</p>
                  </button>
                ) : (
                  <button
                    onClick={() => hitungScoin()}
                    className="px-4 py-2 rounded text-white bg-green-400"
                  >
                    <p>Kirim Undangan</p>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
    // <div
    //   className="w-full flex flex-col dark:text-white pt-16 px-10"
    //   style={{ minHeight: "100vh" }}
    // >
    //   <div className="w-full">
    //     <button
    //       onClick={() => window.history.back()}
    //       className="flex flex-row items-center"
    //     >
    //       <ChevronLeftIcon className="h-4 w-4 mr-2" />
    //       <p>Kembali</p>
    //     </button>
    //   </div>

    //   <div className="flex flex-row gap-4 w-full py-12">
    //     <div className="w-3/12 bg-gray-300 dark:bg-gray-700 rounded-lg p-4">
    //       <h1 className="text-xl font-bold text-center text-gray-800 dark:text-white">
    //         UNDANG
    //       </h1>
    //       <div className="flex flex-col my-4">
    //         <div className="flex flex-col">
    //           <p className="my-2 dark:text-gray-300">Pilih User</p>
    //           <SMSelect data={type} />
    //         </div>
    //         <div className="flex flex-col">
    //           <p className="my-2 dark:text-gray-300">ID Kuesioner</p>
    //           <SMSelect data={type} />
    //         </div>
    //         <div className="flex flex-col">
    //           <p className="my-2 dark:text-gray-300">Pilih Daftar Responden</p>
    //           <SMSelect data={type} />
    //         </div>
    //       </div>

    //       <div className="flex justify-center items-center">
    //         <button className="bg-green-600 text-white rounded px-4 py-2">
    //           Undang
    //         </button>
    //       </div>
    //     </div>
    //     <div className="w-9/12 rounded-lg p-4 flex-col text-center justify-center my-auto">
    //       <div className="flex flex-col text-center">
    //         <h1>Tgl: 31/05/2020</h1>
    //         <h1 className="text-3xl font-bold">KUESIONER SARPRAS</h1>
    //         <h1 className="text-lg text-blue-300">
    //           Kuesioner untuk mengetahui sarana prasaran sekolah
    //         </h1>

    //         <div className="grid grid-flow-col auto-cols-max gap-4 mx-auto justify-center my-6">
    //           <button className="px-6 py-2 bg-blue-200 rounded-lg border border-blue-600">
    //             <h1 className="text-blue-600">{idKuesioner}</h1>
    //           </button>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default UndangKuesioner;
